import { JOURNEY_EVENTS_METRICS } from 'modules/billing/constants';

export const JOURNEY_EVENTS_CARD_IDS = {
  cardId: 'journey-events-metrics',
};

export const JOURNEY_EVENTS_CARD_TEXT = {
  cardTitle: 'Journey events',
  jvtCountDescription: '',
  jvtCountName: 'Total events tracked',
  jvtMonthlyDescription: '',
  jvtMonthlyName: 'Total events by month',
  jvtYearlyDescription: '',
  jvtYearlyName: 'Total events by year',
  projectBreakdownUrl: '/payments/info/journeyEventsUsage',
};

export const JOURNEY_EVENTS_METRIC_NAMES = [JOURNEY_EVENTS_METRICS.jvtCount];

export const JOURNEY_EVENTS_TABLE_COLUMNS = [{ label: 'Project' }, { label: 'Events tracked' }];
